// Hook dinámico para altura de fila basado en rendimiento
export { default as useTableRowHeight } from '../hooks/useTableRowHeight'

// Constante para compatibilidad con código existente
// @deprecated: Use useTableRowHeight() hook instead for dynamic performance-based row height
export const heightRowTable = import.meta.env.VITE_IS_PRODUCTION === 'true' ? 35 : 24
export const heightRowHeaderTable = import.meta.env.VITE_IS_PRODUCTION === 'true' ? 24 : 20

export const fontSizeTable = 12
